import { handleRedirect } from 'src/features/redirect/utils';

export const getServerSideProps = async () => {
  /**
   * NOTE: Leaving this page blank to prevent the user from being redirected to the wrong page
   * and this is a placeholder for generic redirects to be implemented in the future
   */

  return handleRedirect('/support');
};

const Index = () => {
  return null;
};

export default Index;
